import {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useRef,
} from 'react';
import { useLocation } from 'react-router-dom';
import { isToday, parse, isAfter, isPast, addDays } from 'date-fns'; //2025.05 COMTEC kawaji ADD --isAfter追加

import {
  getYoyakuInfo,
  cancelYoyaku,
  GetYoyakuSbtList,
  openSystem,
  checkHeartbeat,
  setSysForWH, //2024.09 COMTEC kawaji ADD
} from '../logics/apiLogic';
import {
  getYoyakuKbn,
  ReceiveTeihoReceptionType,
  ReceiveEventReceptionType,
  inputInfo,
  Job,
  NavigateState,
  YoyakuSbtKbn,
  ComCubeConnectSbtList,
} from '../types/teikihoan/commonDefinition';
import { usePageNavigate } from './usePageNavigate';

type yoyakuSbtList = {
  name: string;
  key: string;
};

export const useResevation = () => {
  const [yoyakuSbtList, setYoyakuSbtList] = useState<yoyakuSbtList[]>([]);
  const [yoyakuSearchInfo, setYoyakuSearchInfo] = useState<{
    uketsuke_no: string;
    yoyaku_sbt_cd: YoyakuSbtKbn;
  }>({ uketsuke_no: '', yoyaku_sbt_cd: YoyakuSbtKbn.nodata }); // 予約情報
  const [customerInfo, setCustomerInfo] = useState<inputInfo | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>(''); // エラーメッセージ
  const [getDataMsg, setGetDataMsg] = useState<string>(''); // メッセージ
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [digOpen, setDigOpen] = useState<boolean>(false); // ダイアログ表示フラグ
  //2024.09 COMTEC kawaji MOD START
  // const [yoyakuIsToday, setYoyakuIsToday] = useState<boolean>(false); // 本日受付フラグ
  const [yoyakuIsToday, setYoyakuIsToday] = useState<{
    isToday: boolean;
    text: string;
    noChangeDay: boolean; //2025.10 COMTEC kawaji ADD
  }>({ isToday: false, text: '', noChangeDay: false }); // 本日受付フラグ //2025.10 COMTEC kawaji ADD --isChangeDay追加
  const [displayRirekiLink, setDisplayRirekiLink] = useState<{
    isDisplay: boolean;
    link: string;
  }>({ isDisplay: false, link: '' }); // 履歴リンク表示フラグ
  //2024.09 COMTEC kawaji MOD END
  const nosRef = useRef<{ customerNo: string; kyokyusakiNo: string }>({
    customerNo: '',
    kyokyusakiNo: '',
  });
  const [eGuid, setEGuid] = useState<string>(''); //2024.09 COMTEC kawaji ADD

  const location = useLocation();
  const { menuPage } = usePageNavigate();
  const params = location.state;
  // //2024.10 COMTEC kawaji ADD START
  // const actionApi: string = process.env
  //   .REACT_APP_WEB_HIDAMARI_LOGIN_API as string;
  // const [rollbackApi, setRollbackApi] = useState<string>('');
  // //2024.10 COMTEC kawaji ADD END

  /****************************************
   * 予約種別リスト取得
   ****************************************/
  const yoyakuList = useCallback(async () => {
    const data = await GetYoyakuSbtList();
    if (data.result === 0) {
      const yList = data.yoyaku_sbt_list.map(
        (row: {
          job_sbt_cd: string;
          job_sbt_name: string;
          display_sgn: boolean;
          display_no: number;
        }) => {
          return { name: row.job_sbt_name, key: row.job_sbt_cd };
        }
      );
      setYoyakuSbtList(yList);
    } else {
      setErrorMsg('サービスの一覧が取得できませんでした。');
      setYoyakuSbtList([]);
    }
  }, []);

  /****************************************
   * 予約情報セット
   * @param data
   * @returns
   ****************************************/
  const setYoyakuCustomerInfo = useCallback(
    (data: any) => {
      if (data === null) {
        setCustomerInfo(null);
        return;
      }

      //2025.05 COMTEC kawaji MOD START
      // const cList = data.uketsuke_info_list ?? JSON.parse(data);

      //'base_date'を除外して表示
      const cListTmp = data.uketsuke_info_list ?? JSON.parse(data);
      const cList = cListTmp.filter((x: any) => x.subtitle !== 'base_date');
      //2025.05 COMTEC kawaji MOD END

      setCustomerInfo(cList);
      DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
    },
    [setCustomerInfo]
  );

  //2024.09 COMTEC kawaji ADD START
  /****************************************
   * うぇぶひだまりお客様情報連携用のシステム情報登録
   ****************************************/
  const InsertSysForWH = async () => {
    try {
      if (
        params.guid === undefined ||
        params.guid === null ||
        params.guid === ''
      ) {
        const param = {
          transition_source: params.source ?? '',
          token: params.token ?? '',
          event_sbt_cd: params.event_sbt ?? '',
          step: 0,
          from_page: 'e-rsv',
        };
        const data = await setSysForWH(param);
        if (data.result !== 0) {
          throw new Error('error');
        }
        setEGuid(data.guid);

        // //2024.10 COMTEC kawaji ADD START
        // const rlbk =
        //   process.env.REACT_APP_API_BASE_URL +
        //   'event_wh?guid=' +
        //   data.guid +
        //   '&uketsukeNo=' +
        //   params.uketsuke_no +
        //   '&page=e-rsv';
        // setRollbackApi(rlbk);
        // //2024.10 COMTEC kawaji ADD END
      }
    } catch (e) {
      console.log(e);
    }
  };
  //2024.09 COMTEC kawaji ADD END

  /****************************************
   * レンダリング前処理
   ****************************************/
  useLayoutEffect(() => {
    //サービスリスト取得
    yoyakuList();
    //ログイン用にシステム情報を登録
    InsertSysForWH(); //2024.09 COMTEC kawaji ADD
  }, []);

  /****************************************
   * レンダリング後処理
   ****************************************/
  useEffect(() => {
    // 予約情報セット
    if (params?.yoyakudata) {
      setYoyakuCustomerInfo(params.yoyakudata);
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
      //2025.06 COMTEC kawaji ADD START
      //閉開栓の予約変更・キャンセル処理期限判定
      const uketukeList = JSON.parse(params.yoyakudata);
      CheckDenkiChangeDateForHeikaisen(uketukeList);
      //2025.06 COMTEC kawaji ADD END
      //2025.10 COMTEC kawaji ADD START
      //イベントの予約変更処理期限判定
      CheckEventUpdateDate(uketukeList, getYoyakuKbn(params.gyomu));
      //2025.10 COMTEC kawaji ADD END
    }
    nosRef.current = {
      customerNo: params.customer_no,
      kyokyusakiNo: params.kyokyusaki_no,
    };
    //2024.09 COMTEC kawaji ADD START
    if (
      params?.msg !== undefined &&
      params?.msg !== null &&
      params?.msg !== ''
    ) {
      setGetDataMsg(params.msg);
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
      DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
    }

    if (params.uketsuke_no !== '' && !params.guid && params.guid !== '') {
      setYoyakuSearchInfo({
        yoyaku_sbt_cd: getYoyakuKbn(params.gyomu),
        uketsuke_no: params.uketsuke_no ?? '',
      });
    }
    //2024.09 COMTEC kawaji ADD END
  }, []);

  useEffect(() => {
    if (customerInfo === null) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 1000);
    }
  }, [customerInfo]);
  /****************************************
   * 戻るボタンクリック
   ****************************************/
  const handlePrevClick = useCallback(async () => {
    if (params?.prepage === 'menu') {
      menuPage(params);
    } else {
      const param = {
        ...params,
        step: 0,
        function: 'teikihoan',
      };
      const result = await openSystem(param);
      if (result.result === 0) {
        window.location.replace(result.redirect_url);
      }
    }
  }, [params]);

  /****************************************
   * 確認ボタンクリック
   * @param e
   ****************************************/
  const handleGetYoyakuInfo = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        //2024.08.27 COMTEC kawaji ADD START
        setGetDataMsg('');
        setYoyakuCustomerInfo(null);

        if (yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.nodata) {
          setErrorMsg('サービスを選択してください。');
          return;
        }
        if (yoyakuSearchInfo.uketsuke_no === '') {
          setErrorMsg('受付番号を入力してください。');
          return;
        }
        if (yoyakuSearchInfo.uketsuke_no.length !== 10) {
          //2024.09 COMTEC kawaji MOD START
          //setErrorMsg('受付番号は10桁の数字を入力してください。');
          const uketukeText =
            yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.teikihoan
              ? '数字'
              : '英数字';
          setErrorMsg(`受付番号は10桁の${uketukeText}を入力してください。`);
          //2024.09 COMTEC kawaji MOD END
          return;
        }
        //2024.08.27 COMTEC kawaji ADD END

        //2024.09 COMTEC kawaji MOD START
        // //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
        // if (
        //   ComCubeConnectSbtList.includes(
        //     yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
        //   )
        // ) {
        //   if (yoyakuSearchInfo.uketsuke_no !== '') {
        //     if (!(await JudgeHeartbeat(yoyakuSearchInfo.uketsuke_no))) return;
        //   }
        // }

        // 予約情報取得前処理
        switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
          case YoyakuSbtKbn.teikihoan:
          case YoyakuSbtKbn.kaisen: //2025.05 COMTEC kawaji ADD
          case YoyakuSbtKbn.heisen: //2025.05 COMTEC kawaji ADD
            //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
            if (
              ComCubeConnectSbtList.includes(
                yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
              )
            ) {
              if (yoyakuSearchInfo.uketsuke_no !== '') {
                if (!(await JudgeHeartbeat(yoyakuSearchInfo.uketsuke_no)))
                  return;
              }
            }

            break;
          case YoyakuSbtKbn.event:
            //うぇぶひだまりのログインチェック、ログインしていない場合はログイン画面へ遷移
            if (
              params.guid === undefined ||
              params.guid === null ||
              params.guid === ''
            ) {
              //リクエストするAPIのURLをセット
              const form = e.currentTarget;

              const actionApi: string = process.env
                .REACT_APP_WEB_HIDAMARI_LOGIN_API as string;
              form.action = actionApi;

              // ログイン後に実行されるAPIのURLをセット
              const rollbackApi: string =
                process.env.REACT_APP_API_BASE_URL +
                'event_wh?guid=' +
                eGuid +
                '&uketsukeNo=' +
                yoyakuSearchInfo.uketsuke_no +
                '&page=e-rsv' +
                //2026.09 NEOTEX kawaji ADD START
                '&dsp=' +
                params.display_mode;
              //2026.09 NEOTEX kawaji ADD END
              const input = form.elements.namedItem(
                'rollback'
              ) as HTMLInputElement;
              input.value = rollbackApi;

              //実行
              form.submit();
              return;
            }
            break;
        }

        //2024.09 COMTEC kawaji MOD END
        setIsLoading(true);
        setYoyakuCustomerInfo(null);
        setErrorMsg('');
        setGetDataMsg('');

        //2024.09 COMTEC kawaji MOD START
        //const data = await getYoyakuInfo(yoyakuSearchInfo);
        const getYoyakuParam = { ...yoyakuSearchInfo, guid: params.guid ?? '' };

        const data = await getYoyakuInfo(getYoyakuParam);
        //2024.09 COMTEC kawaji MOD END
        if (data.result === 0) {
          // 予約情報取得成功
          setYoyakuCustomerInfo(data);
          nosRef.current = {
            customerNo: data.customer_no,
            kyokyusakiNo: data.kyokyusaki_no,
          };
          const yoyakuDay = parse(
            data.sagyo_yotei_ymd as string,
            'yyyy/MM/dd',
            new Date()
          );
          // 予約日が本日の場合、予約変更、キャンセルボタンを非活性化する
          if (isToday(yoyakuDay)) {
            //2024.09 COMTEC kawaji MOD START
            // setYoyakuIsToday(true);

            let todayWarningText = '';
            switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
              case YoyakuSbtKbn.teikihoan:
                todayWarningText =
                  '申し訳ございませんが、定期保安調査当日の予約変更の受付は電話のみとなります。お手数ですが、日本ガスカスタマーサポート（099-224-5232）までご連絡ください。';
                break;
              case YoyakuSbtKbn.event:
                todayWarningText =
                  '当日の予約変更・キャンセルは受け付けておりません。\\n当日キャンセルのご連絡、その他のお問い合わせはこちらまで\\n日本ガス ガス展事務局：ei-kikaku@nihongas.co.jp';
                break;
            }
            setYoyakuIsToday({
              isToday: true,
              text: todayWarningText,
              noChangeDay: true, //2025.10 COMTEC kawaji MOD --noChangeDay追加
            });
            //2024.09 COMTEC kawaji MOD END
          } else {
            //2024.09 COMTEC kawaji MOD START
            // setYoyakuIsToday(false);
            //2025.10 COMTEC kawaji MOD START
            // setYoyakuIsToday({ isToday: false, text: '' });
            setYoyakuIsToday({
              isToday: false,
              text: '',
              noChangeDay: false,
            });
            //2025.10 COMTEC kawaji MOD END
            //2024.09 COMTEC kawaji MOD END
          }

          //2025.06 COMTEC kawaji ADD START
          //閉栓時の予約変更・キャンセル処理期限判定
          CheckDenkiChangeDateForHeikaisen(data.uketsuke_info_list);
          //2025.06 COMTEC kawaji ADD END
          //2025.10 COMTEC kawaji ADD START
          //イベントの場合、予約変更不可日を取得し、それ以降は予約変更ボタンを非活性化する
          CheckEventUpdateDate(
            data.uketsuke_info_list,
            yoyakuSearchInfo.yoyaku_sbt_cd
          );
          //2025.10 COMTEC kawaji ADD END
        } else if (data.result === 9) {
          // 予約情報なし
          setGetDataMsg(data.error_message);
          DisplayKurashiRirekiLink(true); //2024.09 COMTEC kawaji ADD
        } else {
          // 予約情報取得エラー
          setErrorMsg('予約情報が取得できませんでした。');
        }
      } catch (e: any) {
        if (e.code === 'ECONNABORTED') {
          setErrorMsg(
            '一定時間経過したため、情報が取得できませんでした。もう一度始めからやり直してください。'
          );
        } else {
          setErrorMsg(
            '情報取得に失敗しました。もう一度始めからやり直してください。'
          );
        }
      } finally {
        setIsLoading(false);
      }
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * 予約変更ボタンクリック
   * @param e
   ****************************************/
  const handleYoyakuChange = useCallback(
    async (e: React.FormEvent<HTMLButtonElement>) => {
      e.preventDefault();
      let cusNo = '';
      //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
      if (
        ComCubeConnectSbtList.includes(
          yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
        )
      ) {
        cusNo =
          nosRef.current.customerNo !== ''
            ? nosRef.current.customerNo
            : params.customer_no;
        //Comcube疎通確認
        if (!(await JudgeHeartbeat(cusNo))) return;
      }
      let param: NavigateState = {
        source: params.source,
        token: params.token,
        mailaddress: params.mailaddress ?? '',
        gyomu: params.gyomu,
      };
      switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
        case YoyakuSbtKbn.teikihoan:
          param = {
            ...param,
            step: 2,
            prepage: params.prepage,
            customer_no: cusNo,
            kyokyusaki_no:
              nosRef.current.kyokyusakiNo !== ''
                ? nosRef.current.kyokyusakiNo
                : params.kyokyusaki_no,
            function: Job.Teikihoan,
            gyomu: Job.Teikihoan,
          };
          break;

        case YoyakuSbtKbn.event:
          const eSbt =
            yoyakuSearchInfo.uketsuke_no.substring(0, 1) === 'H'
              ? '001'
              : '002';
          param = {
            ...param,
            uketsuke_no: yoyakuSearchInfo.uketsuke_no,
            step: 1,
            function: Job.Event,
            gyomu: Job.Event,
            event_sbt: eSbt,
            guid: params.guid ?? '', //2024.09 COMTEC kawaji ADD
            display_mode: params.display_mode ?? '',//2026.09 NEOTEX kawaji ADD
          };
          break;

        //2025.05 COMTEC kawaji ADD START
        case YoyakuSbtKbn.heisen:
          param = {
            ...param,
            uketsuke_no: yoyakuSearchInfo.uketsuke_no,
            step: 1,
            function: Job.Heisen,
            gyomu: Job.Heisen,
            guid: '',
          };
          break;
        case YoyakuSbtKbn.kaisen:
          param = {
            ...param,
            uketsuke_no: yoyakuSearchInfo.uketsuke_no,
            step: 1,
            function: Job.Kaisen,
            gyomu: Job.Kaisen,
            guid: '',
          };
          break;
        //2025.05 COMTEC kawaji ADD END
      }

      const result = await openSystem(param);
      if (result.result === 0) {
        window.location.replace(result.redirect_url);
      }
    },
    [params, yoyakuSearchInfo]
  );

  /****************************************
   * キャンセルボタンクリック
   ****************************************/
  const handleCancelClick = useCallback(async () => {
    //ComCubeと接続する必要があるサービスの場合、ComCubeへ疎通確認を行う
    if (
      ComCubeConnectSbtList.includes(
        yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn
      )
    ) {
      //Comcube疎通確認
      if (
        !(await JudgeHeartbeat(
          nosRef.current.customerNo !== ''
            ? nosRef.current.customerNo
            : params.customer_no
        ))
      )
        return;
    }
    //ダイアログ表示
    setDigOpen(true);
  }, [yoyakuSearchInfo]);

  /****************************************
   * 予約キャンセル処理
   * @param e
   ****************************************/
  const onYoyakuCancel = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        setIsLoading(true);

        //#region 2024.09 COMTEC kawaji DEL START
        // let teihoParam: ReceiveTeihoReceptionType | null = null;
        // let eventParam: ReceiveEventReceptionType | null = null;
        // switch (yoyakuSearchInfo.yoyaku_sbt_cd) {
        //   case YoyakuSbtKbn.teikihoan:
        //     teihoParam = {
        //       token: params.token,
        //       is_web_hidamari_entry: false,
        //       customer_no:
        //         nosRef.current.customerNo !== ''
        //           ? nosRef.current.customerNo
        //           : params.customer_no,
        //       kyokyusaki_no:
        //         nosRef.current.kyokyusakiNo !== ''
        //           ? nosRef.current.kyokyusakiNo
        //           : params.kyokyusaki_no,
        //       request_date_day: '',
        //       request_date_time: '',
        //       request_date_time_cd: '',
        //       tachiaisha_kbn_name: '',
        //       tachiaisha_kbn_cd: '',
        //       tachiaisha_name: '',
        //       tachiaisha_phone_no: '',
        //       customer_name: '',
        //       customer_name_kana: '',
        //       post_no: '',
        //       gyosei_shi_ku_name: '',
        //       gyosei_cho_name: '',
        //       chomoku_banchi: '',
        //       heya_no: '',
        //       tel_no: '',
        //       mail_address: '',
        //       encrypt_mail_address: params.mailaddress ?? '',
        //       transition_source: params.source,
        //       tenken_yotei_eigyosho_cd: '',
        //       yoyaku_sbt_cd: yoyakuSearchInfo.yoyaku_sbt_cd as YoyakuSbtKbn,
        //       sakujo_sgn: true,
        //     };
        //     break;

        //   case YoyakuSbtKbn.event:
        //     eventParam = {
        //       token: params?.token ?? '',
        //       uketsuke_no: yoyakuSearchInfo.uketsuke_no ?? '',
        //       p_customer_no: '',
        //       yoyaku_sbt_cd: YoyakuSbtKbn.event,
        //       event_sbt_cd: params?.sbt ?? '',
        //       event_no: '',
        //       request_date_day_cd: 0,
        //       request_date_time_cd: 0,
        //       customer_name: '',
        //       customer_name_kana: '',
        //       customer_family_name: '',
        //       customer_first_name: '',
        //       customer_family_name_kana: '',
        //       customer_first_name_kana: '',
        //       attendance: 0,
        //       attendance_adults: 0,
        //       attendance_kids: 0,
        //       remarks: '',
        //       event_status_cd: '',

        //       post_no: '',
        //       gyosei_shi_ku_name: '',
        //       gyosei_cho_name: '',
        //       chomoku_banchi: '',
        //       heya_no: '',
        //       tel_no: '',
        //       mail_address: '',
        //       transition_source: '',
        //       sakujo_sgn: true,
        //     };
        //     break;
        // }
        //#endregion 2024.09 COMTEC kawaji DEL END

        const result = await cancelYoyaku(
          yoyakuSearchInfo.uketsuke_no,
          yoyakuSearchInfo.yoyaku_sbt_cd,
          //2024.09 COMTEC kawaji MOD START
          // teihoParam,
          // eventParam
          params.source,
          params?.token
          //2024.09 COMTEC kawaji MOD END
        );
        if (result.result === 0) {
          setGetDataMsg('予約をキャンセルしました。');
          setYoyakuCustomerInfo(null);
          params.yoyakudata = null;
          setYoyakuSearchInfo({
            uketsuke_no: '',
            yoyaku_sbt_cd: YoyakuSbtKbn.nodata,
          });
        } else {
          setErrorMsg('予約キャンセルに失敗しました。 ' + result.error_message);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
        setDigOpen(false);
      }
    },
    [params, yoyakuSearchInfo]
  );

  /****************************************
   * サービスセレクトボックス変更
   * @param e
   ****************************************/
  const handleSelectChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setYoyakuSearchInfo({
        ...yoyakuSearchInfo,
        yoyaku_sbt_cd: e.target.value as YoyakuSbtKbn,
      });
      DisplayKurashiRirekiLink(false); //2024.09 COMTEC kawaji ADD
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * 予約番号入力変更
   * @param e
   ****************************************/
  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setYoyakuSearchInfo({
        ...yoyakuSearchInfo,
        uketsuke_no: e.target.value,
      });

      // //2024.10 COMTEC kawaji ADD START
      // setRollbackApi(
      //   process.env.REACT_APP_API_BASE_URL +
      //     'event_wh?guid=' +
      //     eGuid +
      //     '&uketsukeNo=' +
      //     e.target.value +
      //     '&page=e-rsv'
      // );
      // //2024.10 COMTEC kawaji ADD END
    },
    [yoyakuSearchInfo]
  );

  /****************************************
   * Comcube疎通確認
   * @param no　お客さま番号　または　受付番号
   ****************************************/
  const JudgeHeartbeat = async (no: string) => {
    const chkHB = await checkHeartbeat({
      judgement_no: no,
    });
    if (chkHB.result !== 0) {
      menuPage(params);
      return false;
    }

    return true;
  };

  //2024.09 COMTEC kawaji ADD START
  /****************************************
   * 暮らしサービス履歴リンク表示・非表示
   * @param no　お客さま番号　または　受付番号
   ****************************************/
  const DisplayKurashiRirekiLink = useCallback(
    (value: boolean) => {
      setDisplayRirekiLink({
        isDisplay: value,
        link: value
          ? (process.env.REACT_APP_WEB_HIDAMARI_RIREKI_URL as string)
          : '',
      });
    },
    [displayRirekiLink]
  );
  //2024.09 COMTEC kawaji ADD END

  //#region 2025.06 COMTEC kawaji ADD START
  /****************************************
   * 閉栓時の予約変更・キャンセル処理期限判定処理
   * @param data　予約受付内容リスト
   ****************************************/
  const CheckDenkiChangeDateForHeikaisen = useCallback(
    (data: any) => {
      /********************************
       * 閉栓時の予約変更・キャンセル処理期限
       * ・ガス　前日23：59まで
       * ・電気　3営業日前23：59まで
       * ※ガス電気同時予約の場合は、それぞれの期限を設定する
       ********************************/
      const GOJITSU_CHANGE_NG =
        '申し訳ございませんが、現在この予約の変更はお電話でのみ承っております。お手数ですが、お電話（099-250-5111）にてお手続きください。';
      const GAS_STR = 'ガス';
      const DENKI_STR = '電気';
      const CHANGE_OK_STR = 'の変更のみ受付可能です。';
      const CHANGE_TEL_STR =
        'の予約変更の場合は、恐れ入りますが、お電話（099-250-5111）にてお手続きください。';

      if (
        yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.heisen ||
        yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.kaisen ||
        params.gyomu === Job.Heisen
      ) {
        //ガスの予約日を取得
        const gasDate = data.filter((x: any) => x.subtitle.includes('ガス'));
        //ガス予約日をDate型に変換
        const gasYoyakuDay =
          gasDate.length > 0 ? parseJapaneseDate(gasDate[0].value) : null;

        //電気の予約日Valueを取得
        const denkiRow = data.filter((x: any) => x.subtitle.includes('電気'));

        //電気の予約変更不可日があるか確認
        const denkiData = data.filter((x: any) => x.subtitle === 'base_date');
        //電気予約変更不可日をDate型に変換
        const denkiLimitDay =
          denkiData.length === 0
            ? null
            : denkiRow[0].value.includes('※')
              ? new Date(new Date().setHours(0, 0, 0, 0))
              : new Date(denkiData[0].value);

        //******* 予約変更・キャンセル可チェック ********/
        if (denkiLimitDay === null) {
          //========= ガス単独 =========//
          if (gasYoyakuDay !== null && isAfter(new Date(), gasYoyakuDay)) {
            //変更期限切れのため、変更不可
            //メッセージセット
            setYoyakuIsToday({
              isToday: true,
              text: GOJITSU_CHANGE_NG,
              noChangeDay: true,
            });
          }
        } else if (gasYoyakuDay === null) {
          //========= 電気単独 =========//
          if (isAfter(new Date(), denkiLimitDay)) {
            //変更期限切れのため、変更不可
            //メッセージセット
            setYoyakuIsToday({
              isToday: true,
              text: GOJITSU_CHANGE_NG,
              noChangeDay: true,
            });
          }
        } else {
          //========= ガス電気 =========//
          if (gasYoyakuDay <= denkiLimitDay) {
            //========= 先にガスの変更期限が来る場合 =========//
            if (isAfter(new Date(), gasYoyakuDay)) {
              //今日がガスの変更期限切れのため、ガスは変更不可

              //電気は変更期限内かをチェック
              if (isAfter(new Date(), denkiLimitDay)) {
                //電気も変更不可の場合は変更・キャンセルボタンを非活性化
                setYoyakuIsToday({
                  isToday: true,
                  text: GOJITSU_CHANGE_NG,
                  noChangeDay: true,
                });
              } else {
                //電気の変更が可能な場合はメッセージ表示、変更・キャンセルボタン活性化
                let msg = DENKI_STR + CHANGE_OK_STR;
                //ガスの作業が完了でない場合は電話変更可のメッセージを表示
                if (!gasDate[0].value.includes('※')) {
                  msg += GAS_STR + CHANGE_TEL_STR;
                }
                setYoyakuIsToday({
                  isToday: false,
                  text: msg,
                  noChangeDay: false,
                });
              }
            }
          } else {
            //========= 先に電気の期限が来る場合 =========//
            if (isAfter(new Date(), denkiLimitDay)) {
              //今日が電気の変更期限切れのため、電気は変更不可

              //ガスは変更期限内かをチェック
              if (isAfter(new Date(), gasYoyakuDay)) {
                //ガスも変更不可の場合は変更・キャンセルボタンを非活性化
                setYoyakuIsToday({
                  isToday: true,
                  text: GOJITSU_CHANGE_NG,
                  noChangeDay: true,
                });
              } else {
                //ガスの変更が可能な場合はメッセージ表示、変更・キャンセルボタン活性化
                let msg = GAS_STR + CHANGE_OK_STR;
                //電気の作業が完了でない場合は電話変更可のメッセージを表示
                if (!denkiRow[0].value.includes('※')) {
                  msg += DENKI_STR + CHANGE_TEL_STR;
                }
                setYoyakuIsToday({
                  isToday: false,
                  text: msg,
                  noChangeDay: false,
                });
              }
            }
          }
        }
      }
    },
    [yoyakuSearchInfo, params, yoyakuIsToday]
  );

  /****************************************
   * 予約日時の文字列をDate型に変換
   * @param jpDateStr 日時文字列
   ****************************************/
  const parseJapaneseDate = useCallback((jpDateStr: string): Date | null => {
    const match = jpDateStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
    if (!match) return null;

    //日付文字列からそれぞれの年月日を取得
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const day = parseInt(match[3], 10);

    //作業未完了の場合は予約日時、作業完了の場合は当日を取得
    const sagyoDate = jpDateStr.includes('※')
      ? new Date(new Date().setHours(0, 0, 0, 0))
      : new Date(year, month, day);

    return sagyoDate;
  }, []);
  //#endregion 2025.06 COMTEC kawaji ADD END

  //#region 2025.10 COMTEC kawaji ADD START
  /****************************************
   * イベント予約の受付締め切りに伴う予約変更ボタン制御処理
   * @param jpDateStr 日時文字列
   ****************************************/
  const CheckEventUpdateDate = useCallback(
    (data: any, yoyakuSbtCD: string) => {
      //イベントの場合、予約変更不可日を取得し、それ以降は予約変更ボタンを非活性化する
      if (yoyakuSbtCD === YoyakuSbtKbn.event) {
        //予約情報データの'base_date'の行を取得
        let isNoChangeDate = false;
        const noChangeData = data.filter(
          (x: any) => x.subtitle === 'base_date'
        );
        //'base_date'に紐づいている日付を取得
        const noChangeDay =
          noChangeData.length === 0
            ? addDays(new Date(), 1)
            : new Date(noChangeData[0].value);
        //'base_date'に紐づいている日付が今日または過去の場合、変更ボタンを非活性化
        if (isToday(noChangeDay) || isPast(noChangeDay)) {
          isNoChangeDate = true;
        }
        setYoyakuIsToday({
          isToday: false,
          text: '',
          noChangeDay: isNoChangeDate,
        });
      }
    },
    [yoyakuIsToday]
  );

  //#region 2025.10 COMTEC kawaji ADD END

  return {
    yoyakuSbtList,
    yoyakuSearchInfo,
    customerInfo,
    errorMsg,
    getDataMsg,
    isLoading,
    digOpen,
    yoyakuIsToday,
    displayRirekiLink, //2024.09 COMTEC kawaji ADD
    // actionApi, //2024.10 COMTEC kawaji ADD
    // rollbackApi, //2024.10 COMTEC kawaji ADD
    handlePrevClick,
    handleGetYoyakuInfo,
    handleYoyakuChange,
    handleCancelClick,
    onYoyakuCancel,
    handleSelectChange,
    handleInputChange,
    setDigOpen,
  };
};
